"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlignmentIconMap = exports.Alignments = void 0;
var Alignments = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right',
  NONE: 'none',
  JUSTIFY: 'justify'
};
exports.Alignments = Alignments;
var AlignmentIconMap = {
  left: 'imageAlignmentLeft',
  center: 'imageAlignmentMiddle',
  right: 'imageAlignmentRight',
  none: 'imageAlignmentTop'
};
exports.AlignmentIconMap = AlignmentIconMap;